import { documentsAreaMessages } from '../../../messages';
import { Column } from '../../column';
import { ExpiredDocument } from '../expired-document';

export const expiredDocumentsColumns: Column<ExpiredDocument>[] = [
  {
    headerLabel: documentsAreaMessages.titleLabelTable,
    key: 'title',
    type: 'react-node',
  },
  {
    headerLabel: documentsAreaMessages.practiceNumberLabelTable,
    key: 'practiceNumber',
    type: 'string',
  },
  {
    headerLabel: documentsAreaMessages.loadingDateLabelTable,
    key: 'uploadDate',
    type: 'date',
  },
  {
    headerLabel: documentsAreaMessages.expirationDateLabelTable,
    key: 'expirationDate',
    type: 'date',
  },
  {
    headerLabel: documentsAreaMessages.amountLabelTable,
    key: 'amount',
    type: 'amount',
  },
  {
    headerLabel: null,
    key: 'flagIsRead',
    type: 'react-node',
  },
];
